// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"specs_wrapper__lqbTj","table":"specs_table__1OJy8"};